export default __webpack_public_path__ + "static/media/QR.8c45f62d.png";